function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, makeStyles } from '@applyboard/ui-components';
import { Keys, placeholders } from "../Constants";
import { getApplication } from "../../../../store/Selectors";
import EducationStatus from "../EducationStatusComponent";
import { SearchComponentV2 } from "../SearchComponentV2";
import { GetDegreeOptionsByEducationLevel } from "../../Utilities/MapTools";
import SelectComponent from "../SelectComponent";
import { setField } from "../../../../store/Actions/Actions";
import { scrollIfNeeded } from "../../Utilities/Helper";
import { assert } from "../../../../utils/assert";
var useStyles = makeStyles({
  menu: {
    marginBottom: '32px'
  },
  status: {
    marginBottom: '24px'
  }
});
var Question5 = function Question5(props) {
  var countryOfResidence = props.countryOfResidence,
    educationLevel = props.educationLevel,
    educationStatusErrorMessage = props.educationStatusErrorMessage,
    educationCountry = props.educationCountry,
    educationCountryErrorMessage = props.educationCountryErrorMessage,
    educationLevelErrorMessage = props.educationLevelErrorMessage,
    degreeErrorMessage = props.degreeErrorMessage,
    clearError = props.clearError,
    countriesData = props.countriesData,
    educationData = props.educationData,
    isMobile = props.isMobile,
    degree = props.degree;
  var classes = useStyles();
  var options = GetDegreeOptionsByEducationLevel(educationData === null || educationData === void 0 ? void 0 : educationData.levels, educationLevel);

  // eslint-disable-next-line no-restricted-syntax -- TODO: refactor redux state
  useEffect(function () {
    if (!educationLevel || options && !options.find(function (o) {
      return o.id === degree;
    })) {
      props.setField({
        key: Keys.Application.degree,
        value: ''
      });
    } else {
      var _options$find;
      var type = options && ((_options$find = options.find(function (i) {
        return i.id === degree;
      })) === null || _options$find === void 0 ? void 0 : _options$find.value);
      props.setField({
        key: Keys.Application.educationType,
        value: type !== null && type !== void 0 ? type : null
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: fix this
  }, [educationData, educationLevel, options, degree]);
  var degreeRef = useCallback(function (node) {
    return scrollIfNeeded(node);
  }, []);
  assert(countryOfResidence === null || countryOfResidence === void 0 ? void 0 : countryOfResidence.name, 'countryOfResidence should be defined');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    className: classes.status
  }, /*#__PURE__*/React.createElement(EducationStatus, {
    keyName: Keys.Application.educationStatus,
    isMobile: isMobile,
    clearError: clearError,
    errorMessage: educationStatusErrorMessage
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.menu
  }, /*#__PURE__*/React.createElement(SearchComponentV2, {
    keyName: Keys.Application.educationCountry,
    errorMessage: educationCountryErrorMessage,
    clearError: clearError,
    items: countriesData,
    pinnedItems: [countryOfResidence.name],
    placeholder: placeholders.educationCountry,
    isMobile: isMobile,
    isOutlined: true,
    field: educationCountry,
    setField: props.setField
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.menu
  }, /*#__PURE__*/React.createElement(SelectComponent, {
    keyName: Keys.Application.educationLevel,
    errorMessage: educationLevelErrorMessage,
    clearError: clearError,
    items: educationData === null || educationData === void 0 ? void 0 : educationData.families,
    placeholder: placeholders.educationLevel
  })), educationLevel && options && /*#__PURE__*/React.createElement(Box, {
    className: classes.menu,
    ref: degreeRef
  }, /*#__PURE__*/React.createElement(SelectComponent, {
    keyName: Keys.Application.degree,
    errorMessage: degreeErrorMessage,
    clearError: clearError,
    items: options,
    placeholder: placeholders.degree
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  var _ref;
  var application = getApplication(state);
  return _ref = {}, _defineProperty(_ref, Keys.Application.countryOfResidence, application.countryOfResidence), _defineProperty(_ref, "educationCountry", application[Keys.Application.educationCountry]), _defineProperty(_ref, Keys.Application.educationLevel, application.educationLevel), _defineProperty(_ref, "educationStatus", application[Keys.Application.educationStatus]), _defineProperty(_ref, "educationType", application[Keys.Application.educationType]), _defineProperty(_ref, Keys.Application.degree, application.degree), _defineProperty(_ref, "gmatTest", application.gmatTest), _defineProperty(_ref, "greTest", application.greTest), _defineProperty(_ref, "standardizedTests", application.standardizedTests), _ref;
};
var connector = connect(mapStateToProps, {
  setField: setField
});
export default connector(Question5);